"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecutionSupervisor = void 0;
const TTL_IN_MS = 10 * 60 * 1000;
class ExecutionSupervisor {
    constructor(logger, fake = false) {
        this.taskMap = new Map();
        this.logger = logger;
        this.fake = fake;
    }
    async runTask(requestId, task, ttl) {
        if (this.fake) {
            return task();
        }
        return new Promise((resolve, reject) => {
            this.doRunTask(requestId, task, ttl ?? TTL_IN_MS, { resolve, reject }).catch(reject);
        });
    }
    async doRunTask(taskId, task, ttl, responder) {
        const taskEntry = this.taskMap.get(taskId);
        if (taskEntry) {
            this.logger.debug(`Task(${taskId}) is underway. Waiting for response...`);
            taskEntry.responders.push(responder);
            return;
        }
        const newTaskEntry = {
            responders: [responder],
            expires: Date.now() + ttl
        };
        let timeoutId;
        let position = 0;
        try {
            this.taskMap.set(taskId, newTaskEntry);
            const timeoutTask = new Promise((___, reject) => {
                timeoutId = setTimeout(() => {
                    reject(new Error('Timeout'));
                }, TTL_IN_MS);
            });
            const realTask = task().finally(() => {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
            });
            const response = await Promise.race([realTask, timeoutTask]);
            this.logger.debug(`Responding task(${taskId})...`);
            for (; position < newTaskEntry.responders.length; position++) {
                const someResponder = newTaskEntry.responders[position];
                try {
                    someResponder.resolve(response);
                }
                catch (caught) {
                    someResponder.reject(caught);
                }
            }
        }
        catch (caught) {
            for (; position < newTaskEntry.responders.length; position++) {
                const someResponder = newTaskEntry.responders[position];
                someResponder.reject(caught);
            }
        }
        finally {
            this.taskMap.delete(taskId);
            this.logger.debug(`Task(${taskId}) finalized`);
        }
    }
}
exports.ExecutionSupervisor = ExecutionSupervisor;
//# sourceMappingURL=execution-supervisor.js.map